import React, { Component } from 'react'
import { connect } from 'react-redux'
import Autosuggest from 'react-autosuggest';
import { Button } from 'reactstrap';

import { membersListActions, getMembersForCurrentMembersList } from '../../../core/members-list'
import { getCurrentTeamMembersList } from '../../../core/teams-members-list'

import Checkbox from './checkbox'
import MemberItem from './member-item'

const themeSuggest = {
  container: 'react-autosuggest__container w-100',
  input: 'border-0 form-control',
  suggestionsContainer: 'react-autosuggest__suggestions-container position-relative',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'list-group list-group-flush',
  suggestion: 'react-autosuggest__suggestion list-group-item',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
};

const renderSuggestion = (suggestion, data_suggestion) => {

  let text = `${suggestion.first_name} ${suggestion.last_name}`
  return (
    <span className="suggestion-item" dangerouslySetInnerHTML={{ __html: text }} ></span>
  );
}

const renderSuggestionsContainer = ({ containerProps, children, query }) => {
  return (
    <div {...containerProps}>
      {children}
    </div>
  );
}

class MemberSearch extends Component {

  constructor(props) {
    super(props)

    this.state = {
      filters: {
        first_name: '',
      },
      value_id: null,
      value: '',
      suggestions: [],
      filtered_members: this.props.search_members_list.valueSeq()
    }

    this.cleanFilters = this.cleanFilters.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSuggest = this.handleSuggest.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)

    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
    this.getSuggestionValue = this.getSuggestionValue.bind(this)
  }

  componentDidUpdate(prevProps) {
    const { search_members_list } = this.props;

    if (prevProps.search_members_list !== search_members_list) {
      this.setState({
        filtered_members: search_members_list.valueSeq()
      });
    }
  }

  cleanFilters() {
    this.setState({
      filters: {
        first_name: '',
      }
    });
  }

  handleChange(event, { newValue }) {
    const { team_id } = this.props;

    if(!newValue && this.state.value) {
      this.props.findMembers({
        not_team_id: team_id
      });
    }

    this.setState({
      value: newValue
    });
  }

  handleKeyPress(event) {
    const { search_members_list } = this.props;

    if (event.key === 'Enter' || event.type === 'blur') {
      event.preventDefault();
      const formattedSearch = event.target.value.toLowerCase().trim();

      const filtered_members = search_members_list.filter(member => {
        const firstName = member.first_name.toLowerCase();
        const lastName = member.last_name.toLowerCase();
        const email = member.email.toLowerCase();
        const fullName = firstName + ' ' + lastName;
  
        const fullNameIncludeSearch = fullName.includes(formattedSearch);
        const includeEmail = email.includes(formattedSearch);
  
        return fullNameIncludeSearch || includeEmail;
      });
  
      this.setState({
        value_id: null,
        filtered_members
      });
    }
  }

  handleSuggest({ value }) {

  }

  onSuggestionsFetchRequested({ value }) {
    const { members, team_members } = this.props;

    if (value) {
      const inputValue = value.trim().toLowerCase();

      const new_suggestions = [];

      members.forEach(item => {
        if (!team_members.itemsId.contains(item.id) && ((item.first_name ? item.first_name.toLowerCase().indexOf(inputValue) !== -1 : false) ||
          (item.last_name ? item.last_name.toLowerCase().indexOf(inputValue) !== -1 : false) ||
          (item.first_name && item.last_name ? `${item.first_name.toLowerCase()} ${item.last_name.toLowerCase()}`.indexOf(inputValue) !== -1 : false)))
          new_suggestions.push(item);
      });

      this.setState({
        suggestions: new_suggestions
      });
    }
  }
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: []
    });

  }

  getSuggestionValue(suggestion) {
    const { findMembersById } = this.props
    findMembersById(suggestion.id)
    return `${suggestion.first_name} ${suggestion.last_name}`;
  }

  render() {
    const { hanndleNextSection, members, members_selected, handleCheckboxChange, team_members, search_members_list, team_id } = this.props
    const { value, suggestions, value_id, filtered_members } = this.state
    const props = {
      value,
      onChange: this.handleChange,
      onKeyPress: this.handleKeyPress,
      onBlur: this.handleKeyPress,
      placeholder: "Search member"
    };

    let member_list = filtered_members.map((member, index) => {
      if (!team_members.itemsId.contains(member.id))
        return <div key={member.id}>
              <MemberItem 
                team_id={team_id} 
                member={member} 
                isMember={false}
                members_selected={members_selected}
                handleCheckboxChange={handleCheckboxChange}
              />
          </div>
      return null;
    });

    if (value_id) {
      const member = members.get(`${value_id}`)
      member_list = <div key={member.id}>
          <MemberItem 
            team_id={team_id} 
            member={member} 
            isMember={false}
            members_selected={members_selected}
            handleCheckboxChange={handleCheckboxChange}
          />
        </div>
    }

    return (
      <>
        <div className='d-flex align-items-start gap-10'>
          <div className='flex-fill mw-50-lg pr-lg-2'>
              <div className="search-member-input rounded border d-flex align-items-start">
                <span className='text-muted ml-2 my-1 d-block' >
                  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                      <g>
                          <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                              c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                              c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                              c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                              C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                              c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                          <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                              c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                              c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                              s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                              c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                              c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                              C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                              L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                              c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                              C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                              c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                              C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                      </g>
                  </svg>
                </span>
                <Autosuggest 
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsUpdateRequested={this.handleSuggest}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  renderSuggestion={renderSuggestion}
                  renderSuggestionsContainer={renderSuggestionsContainer}
                  getSuggestionValue={this.getSuggestionValue}
                  inputProps={props}
                  theme={themeSuggest}
                />
              </div>
          </div>
          <Button disabled={members_selected.size === 0} color="green-light" size='sm' className='ml-auto' onClick={(e) => { e.preventDefault(); hanndleNextSection({ section: 'save-members' }) }}>
            <svg xmlns="http://www.w3.org/2000/svg" width={14} height={15} viewBox="0 0 14 15" fill='currentColor' className='mt-n1'>
            <path d="M8.3,9.1c0.6-0.5,1.1-1.2,1.3-2s0.2-1.6-0.1-2.4C9.4,3.9,8.9,3.2,8.2,2.8C7.5,2.3,6.7,2,5.9,2
              C5.1,2,4.3,2.3,3.6,2.8C3,3.2,2.5,3.9,2.2,4.7C1.9,5.5,1.9,6.3,2.1,7.1s0.7,1.5,1.3,2c-1,0.4-1.9,1.1-2.7,2
              c-0.1,0.1-0.2,0.3-0.2,0.5s0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.4-0.2c0.7-0.9,2.1-2,4.1-2c2,0,3.3,1.1,4.1,2
              c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3,0,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2,0-0.3-0.2-0.5C10.3,10.2,9.4,9.5,8.3,9.1z M3.3,6
              c0-0.5,0.2-1,0.4-1.5c0.3-0.4,0.7-0.8,1.2-1c0.5-0.2,1-0.3,1.5-0.1c0.5,0.1,1,0.4,1.3,0.7s0.6,0.8,0.7,1.3c0.1,0.5,0,1-0.1,1.5
              s-0.5,0.9-1,1.2C6.9,8.4,6.4,8.6,5.9,8.6c-0.7,0-1.4-0.3-1.9-0.8C3.6,7.3,3.3,6.7,3.3,6z M13.8,8l-1.8,1.8c-0.1,0.1-0.1,0.1-0.2,0.1
              c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1l-0.9-0.9c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5
              c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2l0.4,0.4L12.9,7C12.9,7,13,6.9,13.1,6.9c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1
              c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3s0,0.2,0,0.3C13.9,7.8,13.9,7.9,13.8,8L13.8,8z"/>
            </svg>
            <span className='d-none d-md-inline-block pl-1'>Add to Team</span> 
          </Button>
        </div>

        <div>
          <div className='py-2'>
            {!value && <Checkbox handleCheckboxChange={handleCheckboxChange} select_option={members_selected} label="Select all" checkedLabel="Deselect all" value="all" />}
          </div>
          <div className="members-lists pb-5">
            {member_list}
          </div>
          
        </div>
      </>
    )
  }
}

const mapStateToProps = (state, props) => {
  const { members } = state

  const search_members_list = getMembersForCurrentMembersList(state, props);
  const team_members = getCurrentTeamMembersList(state, props);

  return {
    members,
    team_members,
    search_members_list
  };
};

const mapDispatchToProps = {
  findMembers: membersListActions.findMembers,
  findMembersById: membersListActions.findMembersById,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberSearch);
